/**
 * Harvest Monitoring (Kemandoran) API Configuration
 * Centralized API endpoint constants for the per-foreman-group monitoring report.
 */

export const HARVEST_FOREMAN_API_CONFIG = {
    BASE_PATH: '/api/report/pijar/harvest',
    ENDPOINTS: {
        MONITORING_FOREMAN: '/monitoring-foreman',
    },
} as const;

/**
 * Get full endpoint URL
 */
export const getHarvestForemanEndpoint = (
    endpoint: keyof typeof HARVEST_FOREMAN_API_CONFIG.ENDPOINTS,
): string => {
    return `${HARVEST_FOREMAN_API_CONFIG.BASE_PATH}${HARVEST_FOREMAN_API_CONFIG.ENDPOINTS[endpoint]}`;
};
